import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=cd013b20&scoped=true"
import script from "./PermissionModal.vue?vue&type=script&lang=ts"
export * from "./PermissionModal.vue?vue&type=script&lang=ts"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=cd013b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vu_qgmhcv2zwyplqohcijlq2qcl3q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd013b20",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/.pnpm/@quasar+app@2.4.4_@vue+compiler-sfc@2.7.16_lodash@4.17.21_prettier@2.8.8/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
